@import '~style-sheet-helpers/core.less';
@import (reference) '../../../style.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.fulfillment-barcodes {
  padding: 15px;
}

.fulfillment-barcode-banner {
  margin-top: @space-16;
}

.fulfillment-barcode-description {
  margin: @space-16 0;
}

.fulfillment-barcode-input {
  width: 240px;
}

.divider {
  margin-bottom: @space-24;
}
